<script>
    import Plot from "./components/Plot.svelte";

    export let data;

    function transform(data) {
        // Create the scatter trace given a project
        return [
            {
                x: data.map((x) => x.delta),
                type: "histogram",
            },
        ];
    }

    let layout = {
        title: "Distribution of time since probe scraper last update",
        legend: {
            orientation: "h",
        },
        yaxis: {
            title: {
                text: "time since last update",
            },
        },
        margin: {
            l: 50,
            r: 0,
            b: 50,
        },
    };
</script>

<Plot {data} {transform} {layout} />
